import { render, staticRenderFns } from "./ViolationCard.vue?vue&type=template&id=fc5fc996&"
import script from "./ViolationCard.vue?vue&type=script&lang=js&"
export * from "./ViolationCard.vue?vue&type=script&lang=js&"
import style0 from "./ViolationCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports